import { useEffect } from "react";
import { useLocation } from "react-router-dom";

/**
 * @return {null}
 **/
export default function ScrollToTop() {

  const { pathname } = useLocation();

  useEffect(() => {
    document.getElementById('Brand__Logo').scrollIntoView();
  }, [pathname]);

  return null;
}
